import type { RouteRecordRaw } from 'vue-router';

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/features/auth/pages/LoginPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/register',
    redirect: '/login',
  },
  {
    path: '/google-sign-in-unavailable',
    name: 'GoogleSignInUnavailable',
    component: () => import('@/features/auth/pages/GoogleSignInUnavailablePage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/verify-email',
    name: 'VerifyEmail',
    component: () => import('@/features/auth/pages/VerifyEmailPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/personal-home',
    redirect: '/',
  },
  {
    path: '/welcome',
    redirect: '/',
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/features/auth/pages/ForgotPasswordPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/features/auth/pages/ResetPasswordPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/accept-invitation',
    name: 'AcceptInvitation',
    component: () => import('@/features/auth/pages/AcceptInvitationPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/trial-application',
    name: 'TrialApplication',
    component: () => import('@/features/public/trial/pages/TrialApplicationPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/terms',
    name: 'TermsOfService',
    component: () => import('@/features/public/legal/pages/TermsOfServicePage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: () => import('@/features/public/legal/pages/PrivacyPolicyPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/docs',
    name: 'ApiDocs',
    component: () => import('@/features/public/docs/pages/ApiDocsPage.vue'),
    meta: { requiresAuth: false },
  },
];
